import { useContext } from 'react';

import { STREAM_ACTIVITY_CONTEXT, StreamActivityContext } from './StreamActivityProvider';

/** Give access to the current **Stream Activity** item. */
export function useStreamActivityContext(): StreamActivityContext {
  const context = useContext(STREAM_ACTIVITY_CONTEXT);

  if (!context) {
    throw new Error('useStreamActivityContext must be used within a StreamActivityProvider');
  }

  return context;
}
